<template lang="pug">
.register-body
  .register-row
    .register-group
      .register-key
        span.key-name(:class="{ 'non-active-font': !active }") 開催方法
        span.validation-label(v-if="active") 必須
        slot(name="question")

      .register-note
        span オンライン開催はご家族向けにライブ配信機能を使用可能です。
        br
        span オンライン開催は月に1回（最大1時間）できます。
      .register-value.radios(:class="[ { 'non-active': !active } ]")
        label.register-radio-label
          input#type-1.register-radio-form(
            v-model="_value"
            name="event-hold-type"
            type="radio"
            :value="1"
            v-validate="{ required: true }"
            data-vv-as="開催方法"
            :disabled="!active")
          span.register-radio-text 現地開催
        label.register-radio-label
          input#type-2.register-radio-form(v-model="_value" name="event-hold-type" type="radio" :value="2" :disabled="!active")
          span.register-radio-text オンライン開催
        label.register-radio-label
          input#type-0.register-radio-form(v-model="_value" name="event-hold-type" type="radio" :value="0" :disabled="!active")
          span.register-radio-text 現地とオンライン開催

      .error-messages(v-for="error in errors.collect('event-hold-type')")
        label.error-message {{ error }}
        br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { userStore } from "@/store/store";
import { EventHoldType } from "@/commons/services/Events";
import { PlanType } from "@/commons/services/Plans";

/**
 * ### 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputEventHoldType extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: EventHoldType;

  /** 活性にするか否か */
  @Prop({ default: true })
  public active!: boolean;

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): EventHoldType {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: EventHoldType) {
    this.$emit("input", newValue);
    return;
  }
  public mounted(): void {
    this.planType = userStore.facility.planType;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.register-note {
  margin-bottom: 4px;
}
// ラジオボタンは横幅に応じてラップする
.radios {
  flex-wrap: wrap;
}

.radios.non-active {
  .register-radio-text {
    color: $btn-font-disable !important;
    cursor: not-allowed !important;

    &:hover {
      background: $bg-default !important;
    }
  }
  .register-radio-form:checked + .register-radio-text {
    background: $btn-disable !important;
    color: $btn-font-disable !important;
    border: 1px solid $btn-disable !important;
  }
}
.non-active-font {
  color: $form-border-color;
}
</style>
